import React from "react";

import { useNavigate } from "react-router-dom";

const HomeProductCard = ({ product, category, view_all }) => {
  const navigate = useNavigate();
  return (
    <div
      onClick={() =>
        navigate(`/product/${product._id}/${category}?view_all=${view_all}`)
      }
      className="cursor-pointer flex flex-col items-start overflow-hidden mr-2"
    >
      <div className="h-[18rem]">
        <img
          className="object-cover object-top w-full h-full"
          src={`${product?.images[0]}`}
          alt={product?.title}
        />
      </div>
      <div className="mt-3 inline">
        <h3 className="text-sm font-semibold text-[#b28585]">
          {product?.brand}
        </h3>
        <h3 className="text-sm font-medium text-[#b28585]">{product?.title}</h3>
        <p className="mt-2 text-sm inline text-[rgb(255,0,0)] flex">
          <p className="text-[#000] mr-2">&#8377;{product.discountedPrice}</p>
          <p className="line-through mr-0 text-gray-500">
            &#8377;{product.price}
          </p>
          ({product.discountPercent}%OFF)
        </p>
      </div>
    </div>
  );
};

export default HomeProductCard;
